var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEthiopia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 20.0001C0 22.4466 0.440078 24.7901 1.24406 26.9568L20 28.6957L38.7559 26.9567C39.56 24.7901 40 22.4466 40 20.0001C40 17.5872 39.5726 15.2741 38.7895 13.1325L20 11.3044L1.21047 13.1326C0.427422 15.2741 0 17.5872 0 20.0001H0Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 40C28.5993 40 35.9302 34.5725 38.756 26.9565H1.24402C4.06988 34.5725 11.4007 40 20 40Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 6.10352e-05C11.4007 6.10352e-05 4.06988 5.42756 1.24402 13.0436H38.7561C35.9302 5.42756 28.5993 6.10352e-05 20 6.10352e-05V6.10352e-05Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 29.5653C25.2828 29.5653 29.5653 25.2828 29.5653 20C29.5653 14.7173 25.2828 10.4348 20.0001 10.4348C14.7173 10.4348 10.4348 14.7173 10.4348 20C10.4348 25.2828 14.7173 29.5653 20.0001 29.5653Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.998 12.593L21.7247 17.9072H27.3214L22.7918 21.1916L24.5321 26.5216L19.998 23.2215L15.4708 26.5155L17.2041 21.1916L12.6787 17.9072H18.2713L19.998 12.593Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8847 21.3226L21.4069 19.5426L24.7923 14.8832L23.3854 13.8609L19.9999 18.5206L16.6147 13.861L15.2076 14.8832L18.5929 19.5429L13.1154 21.3225L13.6527 22.9767L19.1305 21.1969V26.9564H20.8696V21.1968L26.3472 22.9767L26.8847 21.3226Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_407"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthiopia);
export default __webpack_public_path__ + "static/media/ethiopia.ced150e7b783ae3448a765f8235753fd.svg";
export { ForwardRef as ReactComponent };